import { createEvent, createStore, sample } from 'effector'
import { $shipment, changeCity, changeDelivery, changeStock } from '@entities/shipment/model'
import { $basketActualPositions } from '@entities/basket/model'
import { $currentPath } from '@entities/route/model'
import { $isDelivery } from 'src/pages/order/basket/model'
import { pushFx } from 'src/infastruct/effector-utils/attach-router'

export const toggleStockSelector = createEvent()
export const openStockSelectorWithBasketItems = createEvent()

export const openStockForGoods = createEvent<number[]>()
export const $isStockSelector = createStore(false).on(toggleStockSelector, (state) => !state)
export const $goodIds = createStore([] as number[]).reset(toggleStockSelector)

sample({
    clock: openStockSelectorWithBasketItems,
    source: $basketActualPositions,
    fn: (positions) => positions?.map((x) => x.webData.goodId) || [],
    target: $goodIds
})
sample({
    clock: openStockForGoods,
    target: $goodIds
})
sample({
    clock: openStockForGoods,
    fn: () => true,
    target: $isStockSelector
})
sample({
    clock: openStockSelectorWithBasketItems,
    fn: () => true,
    target: $isStockSelector
})
export const toggleAddressSelector = createEvent()
export const $isAddressSelector = createStore(false).on(toggleAddressSelector, (state) => !state)

export const toggleCitySelector = createEvent()
export const $isCitySelector = createStore(false).on(toggleCitySelector, (state) => !state)

sample({
    clock: $currentPath,
    fn: () => false,
    target: [$isStockSelector, $isCitySelector, $isAddressSelector]
})

sample({
    clock: $shipment,
    source: {
        path: $currentPath,
        isDelivery: $isDelivery
    },
    filter: ({ path }) => path.includes('/order/create'),
    fn: ({ isDelivery }) => `/order/basket?isDelivery=${isDelivery}`,
    target: pushFx
})

sample({
    clock: changeStock,
    fn: () => false,
    target: $isStockSelector
})

sample({
    clock: changeDelivery,
    fn: () => false,
    target: $isAddressSelector
})
sample({
    clock: changeCity,
    fn: () => false,
    target: $isCitySelector
})
